import { render, staticRenderFns } from "./ProfileUserMenu.vue?vue&type=template&id=23a8abfe&scoped=true&"
import script from "./ProfileUserMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUserMenu.vue?vue&type=style&index=0&id=23a8abfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8abfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a8abfe')) {
      api.createRecord('23a8abfe', component.options)
    } else {
      api.reload('23a8abfe', component.options)
    }
    module.hot.accept("./ProfileUserMenu.vue?vue&type=template&id=23a8abfe&scoped=true&", function () {
      api.rerender('23a8abfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/ProfileUserMenu.vue"
export default component.exports